import iEnergipresentationApiRequestModel from "./RequestModels/iEnergipresentationApiRequest";
import iEnergipresentationBubbleApiRequestModel from "./RequestModels/iEnergipresentationBubbleApiRequest";
import iEnergipresentationDoubleSourceBubbleApiRequestModel from "./RequestModels/iEnergipresentationDoubleSourceBubbleApiRequest";
import iEnergipresentationYearsModel from "./iEnergipresentationYears";
import iGraphData from "./ResponseModels/iGraphData";

export default class DataHelper {

    private constructor() { }

    public static SafeClone(graphData: iGraphData): iGraphData {
        return this.deepCloneIsh(graphData) as iGraphData;
    };
    private static deepCloneIsh(obj: any): any {
        if (typeof obj === 'function') {
            return undefined;
        }
        if (typeof obj !== 'object' || obj === null) {
            return obj;
        }

        if (Array.isArray(obj)) {
            return obj.map(i => this.deepCloneIsh(i));
        }

        let result: any = {};

        for (let key in obj) {
            if (!obj.hasOwnProperty(key)) {
                continue;
            }
            let value = this.deepCloneIsh(obj[key]);

            if (value !== undefined) {
                result[key] = value;
            }
        }

        return result;
    };

    public static async FetchPXGraphData(graphId: string, callback: Function): Promise<void> {
        try {
            let debug = false;
            if (debug) { console.log('PX graph id: ', graphId); }
            await fetch("https://pxgraf.energimyndigheten.se" + "/api/sq/visualization/" + graphId, {
                credentials: 'same-origin',
                method: "GET",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                keepalive: true
            }).then(response => response.json()
                .then((json) => {
                    if (debug) {
                        console.log("performFetch: Px Graph", "json", json);
                    }
                    if (!response.ok) {
                        throw Error("Något gick fel vid hämtning från pxgraph.energimyndigheten.se: " + (json ? json.ExceptionMessage : json));
                    }
                    else {
                        let newJson = this.transformKeysToCamelCase(json)
                        callback(newJson);
                    }
                })
                .catch((err) => {
                    console.error("Något gick fel i GetPxGraphAsync: ", err);
                    callback();
                })
            );
        }
        catch (err) {
            console.error("Något gick fel i try-catch: ", err);
            callback(false)
        }
    };

    public static async FetchGraphData(apiRequest: iEnergipresentationApiRequestModel, callback: Function, newYears?: iEnergipresentationYearsModel): Promise<void> {
        let fetchCallback = (response: any) => {
            if (!response) {
                callback(response);
            }
            else {
                let cleanedJson = this.removeUnusedProperties(response);
                callback(cleanedJson, newYears);
            }
        };
        await this.performFetch(apiRequest, 'GetGraphDataAsync', fetchCallback);
    };

    public static async FetchGraphOverviewData(apiRequest: iEnergipresentationBubbleApiRequestModel, callback: Function, newYears?: iEnergipresentationYearsModel): Promise<void> {
        let fetchCallback = (response: any) => {
            if (!response) {
                callback(response);
            }
            else {
                callback(response, newYears);
            }
        };
        await this.performFetch(apiRequest, 'GetChartOverviewDataAsync', fetchCallback);
    };

    public static async FetchDoubleGraphOverviewData(apiRequest: iEnergipresentationDoubleSourceBubbleApiRequestModel, callback: Function, newYears?: iEnergipresentationYearsModel): Promise<void> {
        let fetchCallback = (response: any) => {
            if (!response) {
                callback(response);
            }
            else {
                callback(response, newYears);
            }
        };
        await this.performFetch(apiRequest, 'GetDoubleChartOverviewDataAsync', fetchCallback);
    };

    private static pascalToCamel(input: string): string {
        if (!input || input[0] === input[0].toLowerCase()) {
            return input;
        }

        let firstChar = input[0].toLowerCase();
        let rest = input.slice(1);
        return `${firstChar}${rest}`;
    };

    private static transformKeysToCamelCase(obj: any, call?: number): any {
        if (typeof obj !== "object" || obj == null) {
            return obj;
        }

        if (Array.isArray(obj)) {
            return obj.map(i => this.transformKeysToCamelCase(i, (call ?? 0) + 1));
        }

        let newObj = {};

        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
                let newKey = this.pascalToCamel(key);
                let value = obj[key];
                newObj[newKey] = this.transformKeysToCamelCase(value);
            }
        }

        return newObj;
    };

    private static removeUnusedProperties(obj: any): any {
        if (typeof obj !== 'object' || obj === null) {
            return obj;
        }

        if (Array.isArray(obj)) {
            return obj.map(i => this.removeUnusedProperties(i));
        }

        let result: any = {};

        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
                let value = this.removeUnusedProperties(obj[key]);

                if (value !== null && value !== undefined) {
                    result[key] = value;
                }
            }
        }

        return result;
    };

    private static removeIndentFromJsonString(jsonString: string): string {
        const jsonObject = JSON.parse(jsonString);
        const compactJsonString = JSON.stringify(jsonObject);
        return compactJsonString;
    };

    private static async performFetch(apiRequest: any, endPoint: string, callback: Function, debug?: boolean): Promise<void> {
        try {
            if (apiRequest.requests) {
                for (let i = 0; i < apiRequest.requests.length; i++) {
                    if (debug && apiRequest.requests[i].requestBody.length === 0) {
                        console.log("requestBody is empty for request " + i + " to ", endPoint);
                    }
                    apiRequest.requests[i].requestBody = this.removeIndentFromJsonString(apiRequest.requests[i].requestBody);
                }
            }

            apiRequest['lang'] = document.getElementsByTagName('html')[0].lang;
            if (debug) { console.log('req', apiRequest); }
            await fetch("/api/EnergipresentationApi/" + endPoint, {
                credentials: 'same-origin',
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                keepalive: true,
                body: JSON.stringify(apiRequest)
            }).then(response => response.json()
                .then((json) => {
                    if (debug) {
                        console.log("performFetch: " + endPoint, "json", json);
                    }
                    if (!response.ok) {
                        if (apiRequest.requests) {
                            let domain = "okänd källa";
                            if (apiRequest.requests?.[0]?.apiUrl) {
                                let domainStartIndex = apiRequest.requests[0].apiUrl.indexOf("//") + 2;
                                let domainEndIndex = apiRequest.requests[0].apiUrl.substring(domainStartIndex).indexOf("/");
                                domain = apiRequest.requests[0].apiUrl.substring(domainStartIndex, domainEndIndex + domainStartIndex)
                            }
                            throw Error("Något gick fel vid hämtning från " + domain + ": " + (json ? json.ExceptionMessage : json));
                        }
                        else {
                            throw Error("Något gick fel vid hämtning av data. " + JSON.stringify(response))
                        }
                    }
                    else {
                        let newJson = this.transformKeysToCamelCase(json)
                        callback(newJson);
                    }
                })
                .catch((err) => {
                    console.error("Något gick fel i " + endPoint + ": ", err);
                    callback();
                })
            );
        }
        catch (err) {
            console.error("Något gick fel i try-catch: ", err);
            callback(false)
        }
    };
};